import {
	Swiper,
	Navigation,
	Pagination,
	Lazy,
	Controller
} from 'swiper';

const debounce = require('../helpers/debounce');
const { tablet, desktop } = require('../helpers/breakpoints');

const settings = {
	embedded: {
		sizeDesktop: 1,
		sizeTablet: 1,
		sizeMobile: 1,
	},
	regular: {
		sizeDesktop: 2.8,
		sizeTablet: 1.17,
		sizeMobile: 1.22
	},
	large: {
		sizeDesktop: 1.4,
		sizeTablet: 1.18,
		sizeMobile: 1.22
	},
	stories: {
		sizeDesktop: 2.8,
		sizeTablet: 2.35,
		sizeMobile: 1.2
	}
}

const initFor = $parent => {
	const $container = $parent.querySelector('.swiper-container');
	if (!$container) return;

	const $slides = $container.querySelectorAll('.swiper-slide');

	// Swiper prevents duplicate swipers on same element on its own
	// However the current instance does get replaced by the previous which resets the state unnecessarily
	if ($container.closest('.swiper-container-initialized')) return;

	// Determine if swiper navigation buttons exist
	const $navigation = $parent.querySelector('.js-carousel-navigation');
	const $left = $parent.querySelector('.js-carousel-nav-left');
	const $right = $parent.querySelector('.js-carousel-nav-right');
	const hasNavigation = !!$left  || !!$right;

	// Determine if swiper navigation buttons exist
	const $pagination = $parent.querySelector('.swiper-pagination');
	const hasPavigation = !!$pagination;

	// Determine if fraction ("slide 01 out of 12") exists
	const $fraction = $parent.querySelector('.js-carousel-fraction');
	const hasFraction = !!$fraction;

	// Determine sizes
	const type = $parent.getAttribute('data-type') || 'regular';
	const setting = settings[type];
	const widthMobile = setting.sizeMobile;
	const widthTablet = setting.sizeTablet;
	const widthDesktop = setting.sizeDesktop;

	// Render issues because of display none on load
	const useObserver = !!$parent.closest('.modal');

	// Linking this swiper to a specific swiper in a modal
	const modal = $parent.getAttribute('data-carousel-modal')
	const $modal = modal ? document.querySelector(modal) : false;
	const hasSwiperModal = !!$modal;
	const swiperModal = hasSwiperModal && initFor($modal);

	// Lazy Loading settings
	const isLazy = !!$parent.querySelector('.swiper-lazy');

	const swiper = new Swiper($container, {
		direction: 'horizontal',
		init: true,
		watchOverflow: true,
		roundLengths: true,
		freeMode: false,
		spaceBetween: 0,
		slidesPerView: widthMobile,
		mousewheel: true,

		// Render issues because of display none on load
		observer: useObserver,
		observeParents: useObserver,

		// Lazy loading
		preloadImages: !isLazy, // Disable preloading of all images
		lazy: isLazy  && {
			enabled: true,
			loadPrevNext: true,
		},

		// Responsiveness
		breakpoints: {
			[tablet]: {
				slidesPerView: widthTablet
			},
			[desktop]: {
				slidesPerView: widthDesktop
			}
		},
		navigation: hasNavigation && {
			nextEl: $right,
			prevEl: $left
		},
		pagination: hasPavigation && {
			el: $pagination,
			type: 'progressbar',
		},
	});

	// Swiper has a pagination-fraction, however we already use pagination-progressbar.
	// So we set the fraction ourselves.
	if (hasFraction) {
		swiper.on('slideChange', () => {
			const num = swiper.activeIndex + 1;
			const suffix = num < 10 ? '0' : '';
			$fraction.innerHTML = `${suffix}${num}`;
		});
	}

	// Linking this swiper to a specific swiper in a modal
	// Linked two-way so that they remain in sync
	if (hasSwiperModal) {
		swiper.controller.control = swiperModal;
		swiperModal.controller.control = swiper;
	}

	// Through watchOverflow, Swiper will be disabled and navigation buttons hidden in case there are not enough slides for sliding.
	// However we may have additional custom elements, so we sync the hidden state of those elements with swiper.isLocked
	const checkForLock = () => {
		$navigation.classList.toggle('is-hidden', swiper.isLocked);
	}
	swiper.on('lock', () => {
		checkForLock();
	});
	// And run once for initial state
	checkForLock();

	return swiper;
}

const init = ($root = document) => {
	const $parents = $root.querySelectorAll('.js-carousel');
	if ($parents.length === 0) return;

	Swiper.use([Navigation, Pagination, Lazy, Controller]);
	$parents.forEach($parent => initFor($parent));
};

export default {
	init
};